React = require 'react'
$ = require 'jquery'
t = require('views/internal/recup-with-helpers')()
Util = require 'lib/util'
Auth = require 'db/auth'
Dialog = require 'views/lib/dialog'
Controller = require 'controller'
CreateBoardComponent = require 'views/board-create/create-board-component'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
HomeBoardSectionLinksItem = require 'views/home/home-board-section-links-item'

module.exports = class HomeBoardSectionLinks extends React.Component
  displayName: 'HomeBoardSectionLinks'

  constructor: ->
    @addBoard = @addBoard.bind(@)

  addBoard: (e) ->
    Util.preventDefault(e)

    if maybeDisplayMemberLimitsError($(e.target), null, Auth.me())
      return

    { modelCache, orgname } = @props
    orgModel = modelCache.findOne('Organization', 'name', orgname)

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: orgModel

  render: t.renderable ->
    { orgname } = @props

    t.div '.home-board-section', =>

      t.tag HomeBoardSectionLinksItem, {
        onClick: @addBoard
        icon: 'add'
        text: if orgname then 'home-create-team-board' else 'home-create-board'
        showBackground: true
      }

      if orgname
        orgBoardsUrl = Controller.getOrganizationUrl(orgname)
        orgMembersUrl = Controller.getOrganizationMembersUrl(orgname)
        orgAccountUrl = Controller.getOrganizationAccountUrl(orgname)

        t.tag HomeBoardSectionLinksItem, {
          url: orgBoardsUrl
          icon: 'board'
          text: 'home-view-all-boards'
        }
        t.tag HomeBoardSectionLinksItem, {
          url: orgMembersUrl
          icon: 'member'
          text: 'home-view-members'
        }
        t.tag HomeBoardSectionLinksItem, {
          url: orgAccountUrl
          icon: 'gear'
          text: 'home-view-settings'
        }



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-board-section-links.coffee